/* eslint-disable react/destructuring-assignment */
import { DataGrid, GridToolbarExport, frFR } from '@mui/x-data-grid';
import { Typography, Link, Tooltip, Card, Box, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import Label from '../../Label';
import moment from 'moment';
import { ProgressBar } from '../session';
import { alpha } from '@mui/material/styles';
import { lightVeil, greyAlpha, grey, getTone } from '../../../theme/tones';

function renderProgress(params) {
  return <ProgressBar value={Number(params.value)} />;
}

const RelaunchCustomersList = (props) => {
  const { countCustomersList, ...other } = props;
  const theme = useTheme();

  const rows = {};
  if (Object.keys(countCustomersList).length !== 0) {
    Object.keys(countCustomersList).forEach((el) => {
      rows[el] = [];
      Object.keys(countCustomersList[el]).forEach((itemRow) => {
        const row = {
          id: countCustomersList[el][itemRow].id + countCustomersList[el][itemRow].id_session,
          civility: countCustomersList[el][itemRow].civility,
          nom: countCustomersList[el][itemRow].nom,
          prénom: countCustomersList[el][itemRow].prénom,
          email: countCustomersList[el][itemRow].email,
          phone: countCustomersList[el][itemRow].phone,
          status: countCustomersList[el][itemRow].status,
          progression: countCustomersList[el][itemRow].progression,
          name: countCustomersList[el][itemRow].name,
          début_formation: countCustomersList[el][itemRow].début_formation,
          fin_formation: countCustomersList[el][itemRow].fin_formation,
          prix: countCustomersList[el][itemRow].prix,
          source: countCustomersList[el][itemRow].source,
          dernière_connexion: countCustomersList[el][itemRow].last_connection,
          durée: countCustomersList[el][itemRow].duration,
          start_relaunch_date: countCustomersList[el][itemRow].start_relaunch_date,
          sessionId: countCustomersList[el][itemRow].sessionId,
        };
        rows[el].push(row);
      });
    });
  }

  const columns = [
    { field: 'civility',
      headerName: 'Civilité',
      width: 120,
      type: 'singleSelect',
      renderCell: (cellValues) => {
        let civility = '';
        if (cellValues.row.civility === 'Madame') {
          civility = (
            <Typography
              sx={{ whiteSpace: 'normal', color: 'success.main', fontWeight: 700, fontSize: '0.85rem' }}
            >
              {cellValues.row.civility}
            </Typography>
          );
        } else if (cellValues.row.civility === 'Monsieur') {
          civility = (
            <Typography
              sx={{ whiteSpace: 'normal', color: theme.palette.mode === 'light' ? getTone('emerald').deepest : 'success.light', fontWeight: 700, fontSize: '0.85rem' }}
            >
              {cellValues.row.civility}
            </Typography>
          );
        }
        return (civility);
      },
      editable: true,
      valueOptions: ['Madame', 'Monsieur'],
    },
    { field: 'nom',
      headerName: 'Nom',
      width: 150,
      renderCell: (cellValues) => (
        <Typography
          sx={{ whiteSpace: 'normal', fontWeight: 750, fontSize: '0.85rem', color: 'text.primary' }}
        >
          {cellValues.row.nom}
        </Typography>
      ) },
    { field: 'prénom',
      headerName: 'Prénom',
      width: 120,
      renderCell: (cellValues) => (
        <Typography
          sx={{ whiteSpace: 'normal', fontWeight: 600, fontSize: '0.85rem', color: 'text.primary' }}
        >
          {cellValues.row.prénom}
        </Typography>
      ) },
    { field: 'email', headerName: 'Email', width: 220, renderCell: (cellValues) => (<Typography sx={{ whiteSpace: 'normal', fontSize: '0.85rem', color: 'text.secondary', fontWeight: 500 }}>{cellValues.row.email}</Typography>) },
    { field: 'phone', headerName: 'Téléphone', width: 120, renderCell: (cellValues) => (<Typography sx={{ whiteSpace: 'normal', fontSize: '0.85rem', color: 'text.secondary', fontWeight: 500 }}>{cellValues.row.phone}</Typography>) },
    { field: 'status',
      headerName: 'Statut',
      width: 140,
      type: 'singleSelect',
      renderCell: (cellValues) => {
        let statut = '';
        if (cellValues.row.status === 'Inscrit') {
          statut = (
            <Label color="success">
              {cellValues.row.status}
            </Label>
          );
        } else if (cellValues.row.status === 'En attente' || cellValues.row.status === 'À transférer') {
          statut = (
            <Label color="warning">
              {cellValues.row.status}
            </Label>
          );
        } else if (cellValues.row.status === 'InscritD') {
          statut = (
            <Tooltip
              followCursor
              enterDelay={500}
              placement="top"
              title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
                <span key={dec.id} style={{ display: 'block', whiteSpace: 'pre-line' }}>
                  {`${dec.name} session: ${dec.number_session}`}
                </span>
              )) : null}
            >
              <span>
                <Label color="inscritD">
                  {cellValues.row.status}
                </Label>
              </span>
            </Tooltip>
          );
        } else if (cellValues.row.status === 'Décalé') {
          statut = (
            <Tooltip
              followCursor
              enterDelay={700}
              placement="top"
              title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
                <span key={dec.id} style={{ display: 'block', whiteSpace: 'pre-line' }}>
                  {`${dec.name} session: ${dec.number_session}`}
                </span>
              )) : null}
            >
              <span>
                <Label color="secondary">
                  {cellValues.row.status}
                </Label>
              </span>
            </Tooltip>
          );
        } else if (cellValues.row.status === '- de 5 personnes' || cellValues.row.status === 'Annulation' || cellValues.row.status === 'À décaler' || cellValues.row.status === 'Désinscrit') {
          statut = (
            <Label color="error">
              {cellValues.row.status}
            </Label>
          );
        }
        return (statut);
      },
      editable: true,
      valueOptions: ['Inscrit', 'En attente', 'À décaler', 'Décalé', '- de 5 personnes', 'Annulation', 'À transférer', 'Désinscrit'],
    },
    { field: 'progression', headerName: 'Progression', width: 150, renderCell: renderProgress },
    { field: 'name',
      headerName: 'Nom de formation',
      width: 320,
      renderCell: (cellValues) => (
        <Link
          sx={{
            whiteSpace: 'normal',
            fontWeight: 700,
            textDecoration: 'none',
            color: 'primary.main',
            fontSize: '0.85rem',
            '&:hover': { color: 'primary.dark' }
          }}
          component={RouterLink}
          to={`/dashboard/session/${cellValues.row.sessionId}`}
        >
          {cellValues.row.name}
        </Link>
      ) },
    { field: 'début_formation', headerName: 'Début', width: 120, renderCell: (cellValues) => (<Typography sx={{ fontSize: '0.85rem', fontWeight: 500 }}>{cellValues.row.début_formation !== null ? moment(cellValues.row.début_formation).format('DD/MM/YYYY') : ''}</Typography>) },
    { field: 'fin_formation', headerName: 'Fin', width: 120, renderCell: (cellValues) => (<Typography sx={{ fontSize: '0.85rem', fontWeight: 500 }}>{cellValues.row.fin_formation !== null ? moment(cellValues.row.fin_formation).format('DD/MM/YYYY') : ''}</Typography>) },
    { field: 'start_relaunch_date', headerName: 'Début Relance', width: 120, renderCell: (cellValues) => (<Typography sx={{ fontSize: '0.85rem', fontWeight: 500 }}>{cellValues.row.start_relaunch_date !== null ? moment(cellValues.row.start_relaunch_date).format('DD/MM/YYYY') : ''}</Typography>) },
    { field: 'prix', headerName: 'Prix', width: 100, renderCell: (cellValues) => (<Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>{cellValues.row.prix}</Typography>) },
    { field: 'source', headerName: 'Source', width: 140, renderCell: (cellValues) => (<Typography sx={{ fontSize: '0.85rem', color: 'text.secondary', fontWeight: 500 }}>{cellValues.row.source}</Typography>) },
    { field: 'dernière_connexion', headerName: 'Dernière connexion', width: 160, renderCell: (cellValues) => (<Typography sx={{ fontSize: '0.85rem', color: 'text.secondary', fontWeight: 500 }}>{cellValues.row.dernière_connexion !== null ? moment(cellValues.row.dernière_connexion).format('DD/MM/YYYY HH:mm') : ''}</Typography>) },
    { field: 'durée', headerName: 'Durée', width: 100, renderCell: (cellValues) => (<Typography sx={{ fontSize: '0.85rem', color: 'text.secondary', fontWeight: 500 }}>{cellValues.row.durée}</Typography>) },
  ];

  const gridToolbarExport = () => (
    <Box sx={{ p: 1, display: 'flex', gap: 1 }}>
      <GridToolbarExport 
        csvOptions={{
          delimiter: ';',
          utf8WithBom: true,
          disableExport: false,
          fields: ['civility', 'prénom', 'nom', 'email', 'phone', 'name', 'début_formation', 'fin_formation', 'start_relaunch_date', 'prix', 'source', 'status', 'dernière_connexion', 'durée', 'progression']
        }}
        sx={{
          borderRadius: '10px',
          fontSize: '0.8rem',
          fontWeight: 600,
          border: '1px solid',
          borderColor: 'divider',
          px: 2,
          py: 0.5,
          textTransform: 'none',
          color: 'text.primary',
          '&:hover': {
            backgroundColor: 'action.hover'
          }
        }}
      />
    </Box>
  );
  
  return (
    <Card
      {...other}
      sx={{
        borderRadius: '24px',
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper',
        backdropFilter: 'blur(20px)',
        boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.common.black, 0.02)}`,
        overflow: 'hidden',
        p: 2.5
      }}
    >
      {Object.keys(countCustomersList).map((el) => (
        <Box sx={{ mt: el === Object.keys(countCustomersList)[0] ? 0 : 4 }} key={el}>
          <Typography
            variant="h6"
            sx={{ fontWeight: 800, p: 2, mb: 2, color: 'text.primary', borderBottom: `1px solid ${theme.palette.divider}`, letterSpacing: '-0.01em' }}
          >
            {`Avancement des apprenants par date de début ${moment(el).format('DD/MM/YYYY')}`}
          </Typography>
          <Box sx={{ height: 500, width: '100%' }}>
            <DataGrid
              localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              autoHeight={false}
              rowHeight={64}
              rows={rows[el]}
              columns={columns}
              pageSize={25}
              rowsPerPageOptions={[10, 25, 50, 100]}
              components={{ Toolbar: gridToolbarExport }}
              sx={{
                border: 'none',
                px: 2,
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: theme.palette.mode === 'light' ? grey(100) : greyAlpha(900, 0.3),
                  borderBottom: `1px solid ${theme.palette.divider}`,
                  borderRadius: '12px',
                  fontWeight: 700
                },
                '& .MuiDataGrid-columnHeader': {
                  color: 'text.secondary',
                },
                '& .MuiDataGrid-cell': {
                  borderBottom: theme.palette.mode === 'light' ? `1px solid ${grey(100)}` : `1px solid ${lightVeil(0.03)}`,
                  color: 'text.primary',
                  fontSize: '0.85rem'
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: 'action.hover',
                },
                '& .MuiDataGrid-footerContainer': {
                  borderTop: 'none'
                }
              }}
            />
          </Box>
        </Box>
      ))}
    </Card>
  );
};

RelaunchCustomersList.propTypes = {
  countCustomersList: PropTypes.array.isRequired,
};

export default RelaunchCustomersList;
